// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__daAjc","spacing":"Summary_spacing__jQvwB","edit":"Summary_edit__Us2RT"};